import PropTypes from 'prop-types';
import { Navigation } from '@symposium/ui-utilities'; // Misc

export const BREAK_POINT = {
  large: 1056
};
export const PATH_TYPE = Navigation.PATH_TYPE;
export const LOCALE = Navigation.LOCALE;
export const SESSION_URL = '/account/api/v1/session';
export const API_OPTIONS = {
  credentials: 'include',
  headers: {
    Accept: 'application/json; charset=utf-8'
  },
  json: true
};
export const MASTHEAD_COOKIE_PREFIX = 'rhm-masthead';
export const SELECT_HEADER_DATA = {
  ariaLabel: 'Red Hat Marketplace Select Header',
  logoSrc: 'https://marketplace.redhat.com/en-us/assets/red-hat-marketplace-select-logo-horizontal-reverse.svg',
  logoTitle: 'Red Hat Marketplace Select logo',
  navAriaLabel: 'Red Hat Marketplace Select header navigation',
  mobileAriaLabel: 'Red Hat Marketplace Select mobile navigation'
};
export const HEADER_DATA = {
  ariaLabel: 'Red Hat Marketplace header',
  logoSrc: 'https://marketplace.redhat.com/en-us/assets/red-hat-marketplace-logo-horizontal-reverse.svg',
  logoTitle: 'Red Hat Marketplace logo',
  navAriaLabel: 'Red Hat Marketplace header navigation',
  mobileAriaLabel: 'Red Hat Marketplace mobile navigation'
}; // Prop Types

export const menuItemPropType = PropTypes.shape({
  ariaLabel: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  path: PropTypes.string,
  pathType: PropTypes.oneOf([PATH_TYPE.absolute, PATH_TYPE.relative]),
  submenu: PropTypes.arrayOf(PropTypes.shape({
    ariaLabel: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    path: PropTypes.string,
    pathType: PropTypes.oneOf([PATH_TYPE.absolute, PATH_TYPE.relative])
  }))
});
export const userPropType = {
  accountMap: PropTypes.object,
  accountOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    isCurrent: PropTypes.bool
  })),
  currentAccount: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  currentAccountId: PropTypes.string,
  emailAddress: PropTypes.string,
  firstName: PropTypes.string,
  id: PropTypes.string,
  lastName: PropTypes.string
};
export const NAV_ITEM_ID = Navigation.NAV_ITEM_ID;
export const MENU_ITEM_MAP = Navigation.navItemsMap; // Navigation Item definitions

export const {
  aboutMenuItem,
  accessMenuItem,
  accessibilityMenuItem,
  accountSettingsMenuItem,
  blogMenuItem,
  billingMenuItem,
  contactMenuItem,
  datasetsMenuItem,
  deploymentKeysMenuItem,
  documentationMenuItem,
  myOffersMenuItem,
  feedbackMenuItem,
  invoicesMenuItem,
  learnMoreMenuItem,
  logoutMenuItem,
  marketplaceMenuItem,
  myAccountMenuItem,
  myDashboardMenuItem,
  usageMenuItem,
  myClustersMenuItem,
  mySoftwareMenuItem,
  myRequestsMenuItem,
  myUpdatesMenuItem,
  paymentMethodMenuItem,
  pendingChargesMenuItem,
  privacyPolicyMenuItem,
  partnerExperienceMenuItem,
  profileMenuItem,
  partnerProfileMenuItem,
  signInMenuItem,
  supportMenuItem,
  systemStatusItem,
  termsOfUseMenuItem,
  workspaceMenuItem,
  getWorkspaceMenuItem,
  myAccountMenuItems,
  workspaceItems,
  accountSettingsItems: accountItems,
  customizationEditorMenuItem,
  tagManagementMenuItem,
  marketplaceSelectItems,
  marketplaceSelectMenuItem,
  creditsMenuItem,
  rhmTermsOfServiceMenuItem,
  partnerSidenavItems,
  customerAccessMenuItem,
  vendorNavigationItems,
  privateOffersMenuItem,
  partnerProductsMenuItem,
  partnerDocumentationMenuItem,
  learnMoreItems,
  partnerAccessMenuItem,
  partnerLegalLinkItem,
  myCompanyLinkItem,
  partnerMyTeamItem,
  serviceIdItem,
  partnerServiceIdItem,
  paymentSettingsLinkItem,
  performanceMenuItem
} = Navigation.navItems; // Navigation Menus

export const legalMenuItems = [privacyPolicyMenuItem, termsOfUseMenuItem];
export const navigationItems = [learnMoreMenuItem, partnerExperienceMenuItem, blogMenuItem, documentationMenuItem, supportMenuItem];
export const authenticatedNav = [learnMoreMenuItem, blogMenuItem, documentationMenuItem, supportMenuItem];
export const navigationItemsNonUS = [learnMoreMenuItem, documentationMenuItem, supportMenuItem];
export const footerItems = [systemStatusItem, privacyPolicyMenuItem, termsOfUseMenuItem, accessibilityMenuItem];
export const profileNavigationItems = [myAccountMenuItem, rhmTermsOfServiceMenuItem];
export default {
  LOCALE,
  MENU_ITEM_MAP,
  NAV_ITEM_ID,
  PATH_TYPE,
  menuItemPropType,
  userPropType,
  accountItems,
  navigationItems,
  navigationItemsNonUS,
  footerItems,
  aboutMenuItem,
  accessibilityMenuItem,
  accessMenuItem,
  myAccountMenuItems,
  accountSettingsMenuItem,
  blogMenuItem,
  billingMenuItem,
  contactMenuItem,
  datasetsMenuItem,
  deploymentKeysMenuItem,
  myOffersMenuItem,
  feedbackMenuItem,
  legalMenuItems,
  logoutMenuItem,
  marketplaceMenuItem,
  myDashboardMenuItem,
  usageMenuItem,
  myClustersMenuItem,
  myRequestsMenuItem,
  mySoftwareMenuItem,
  myUpdatesMenuItem,
  privacyPolicyMenuItem,
  profileMenuItem,
  partnerProfileMenuItem,
  profileNavigationItems,
  signInMenuItem,
  supportMenuItem,
  termsOfUseMenuItem,
  workspaceMenuItem,
  SESSION_URL,
  creditsMenuItem,
  partnerSidenavItems
};